'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import {
  initNewRelicBrowser,
  recordNewRelicPageAction,
  setNewRelicAttribute,
  setNewRelicPageContext,
} from '@/lib/newrelic-browser';

interface VersionResponse {
  version?: string;
  commit?: {
    sha?: string;
    short?: string;
    branch?: string;
  };
  environment?: string;
}

export const NewRelicInit = () => {
  const pathname = usePathname();

  useEffect(() => {
    initNewRelicBrowser();
    setNewRelicAttribute('environment', process.env.NODE_ENV);

    const handleOnline = () => {
      recordNewRelicPageAction('browser_online');
    };

    const handleOffline = () => {
      recordNewRelicPageAction('browser_offline');
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    fetch('/api/version')
      .then((response) => response.json())
      .then((data: VersionResponse) => {
        setNewRelicAttribute('frontendVersion', data.version);
        setNewRelicAttribute('frontendCommitSha', data.commit?.sha);
        setNewRelicAttribute('frontendCommitShort', data.commit?.short);
        setNewRelicAttribute('frontendBranch', data.commit?.branch);
        setNewRelicAttribute('frontendEnvironment', data.environment);
      })
      .catch(() => undefined);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  useEffect(() => {
    if (!pathname) {
      return;
    }

    setNewRelicPageContext(pathname);
  }, [pathname]);

  return null;
};
